export default "__VITE_ASSET__C8Vg7QOe__"